var _ellipse, _path, _path2, _path3, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLessondone = function SvgLessondone(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 227,
    viewBox: "0 0 200 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.314,
    cy: 111.999,
    rx: 43.8577,
    ry: 44,
    fill: "#48A9A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.973 111.999C161.973 145.053 135.264 171.849 102.317 171.849C69.3703 171.849 42.661 145.053 42.661 111.999C42.661 78.9438 69.3703 52.1485 102.317 52.1485C135.264 52.1485 161.973 78.9438 161.973 111.999Z",
    stroke: "#48A9A6",
    strokeOpacity: 0.6,
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.06 111.999C135.06 129.589 120.846 143.849 103.314 143.849C85.7811 143.849 71.5672 129.589 71.5672 111.999C71.5672 94.4078 85.7811 80.1485 103.314 80.1485C120.846 80.1485 135.06 94.4078 135.06 111.999Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M185.895 111.999C185.895 157.756 148.922 194.849 103.314 194.849C57.7055 194.849 20.732 157.756 20.732 111.999C20.732 66.2413 57.7055 29.1485 103.314 29.1485C148.922 29.1485 185.895 66.2413 185.895 111.999Z",
    stroke: "#48A9A6",
    strokeOpacity: 0.6,
    strokeWidth: 0.3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.314,
    cy: 111.999,
    rx: 17.9418,
    ry: 18,
    fill: "#94D0CD"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.049,
    cy: 25.998,
    rx: 5.9806,
    ry: 6,
    fill: "#94D0CD"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 168.104,
    cy: 61.9985,
    rx: 5.9806,
    ry: 6,
    fill: "#FCEA8F"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.5761,
    cy: 204.999,
    rx: 4.98383,
    ry: 5,
    fill: "#94D0CD"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.01,
    cy: 11.998,
    rx: 2.9903,
    ry: 3,
    fill: "#48A9A6"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.246,
    cy: 87.9985,
    rx: 1.99353,
    ry: 2,
    fill: "#F6C463"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.3624,
    cy: 169.999,
    rx: 2.9903,
    ry: 3,
    fill: "#F7A491"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.6148,
    cy: 213.999,
    rx: 2.9903,
    ry: 3,
    fill: "#FCEA8F"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.4561,
    cy: 112.999,
    rx: 2.9903,
    ry: 3,
    fill: "#FCEA8F"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.5858,
    cy: 224.999,
    rx: 1.99353,
    ry: 2,
    fill: "#48A9A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.625 8.19533C180.272 7.77113 180.329 7.14055 180.752 6.78689L185.346 2.94476C185.769 2.5911 186.397 2.64829 186.75 3.07248C187.102 3.49668 187.045 4.12726 186.622 4.48092L182.029 8.32305C181.606 8.67671 180.977 8.61952 180.625 8.19533Z",
    fill: "#F6C463"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M181.134 2.56174C181.557 2.20808 182.185 2.26527 182.538 2.68947L186.368 7.29794C186.72 7.72214 186.663 8.35272 186.24 8.70637C185.818 9.06003 185.189 9.00285 184.836 8.57865L181.007 3.97018C180.654 3.54598 180.711 2.9154 181.134 2.56174Z",
    fill: "#F6C463"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.574 60.7413C124.089 60.481 123.906 59.8751 124.165 59.3881L126.984 54.0963C127.243 53.6092 127.847 53.4253 128.333 53.6856C128.818 53.9459 129.002 54.5518 128.742 55.0389L125.923 60.3307C125.664 60.8178 125.06 61.0016 124.574 60.7413Z",
    fill: "#90CDCB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M122.937 55.3283C123.196 54.8412 123.8 54.6573 124.286 54.9176L129.561 57.7455C130.046 58.0058 130.229 58.6117 129.97 59.0988C129.71 59.5859 129.106 59.7697 128.621 59.5094L123.346 56.6815C122.861 56.4212 122.677 55.8154 122.937 55.3283Z",
    fill: "#90CDCB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.589 27.3208C10.5652 27.6099 9.50174 27.0117 9.21357 25.9846L6.08286 14.8269C5.79468 13.7999 6.39096 12.7329 7.41468 12.4438C8.43839 12.1547 9.50189 12.7529 9.79006 13.78L12.9208 24.9377C13.2089 25.9647 12.6127 27.0317 11.589 27.3208Z",
    fill: "#FCEA8F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08721 21.9763C1.79904 20.9493 2.39532 19.8823 3.41903 19.5932L14.5406 16.4524C15.5644 16.1632 16.6279 16.7615 16.916 17.7885C17.2042 18.8155 16.6079 19.8825 15.5842 20.1716L4.4626 23.3125C3.43888 23.6016 2.37539 23.0034 2.08721 21.9763Z",
    fill: "#FCEA8F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M174.243 206.075C174.767 205.147 175.942 204.82 176.867 205.346L186.921 211.057C187.847 211.583 188.172 212.762 187.648 213.69C187.124 214.619 185.949 214.945 185.024 214.419L174.97 208.708C174.044 208.182 173.719 207.004 174.243 206.075Z",
    fill: "#F6C463"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M184.741 203.158C185.666 203.684 185.991 204.863 185.467 205.791L179.775 215.878C179.251 216.806 178.076 217.133 177.15 216.607C176.225 216.081 175.899 214.902 176.423 213.974L182.116 203.887C182.64 202.959 183.815 202.632 184.741 203.158Z",
    fill: "#F6C463"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9336 84.4608C17.2453 83.4407 18.3223 82.8673 19.3391 83.1801L30.3855 86.5778C31.4022 86.8905 31.9738 87.971 31.6621 88.9911C31.3503 90.0112 30.2733 90.5846 29.2565 90.2718L18.2102 86.8741C17.1934 86.5614 16.6219 85.4809 16.9336 84.4608Z",
    fill: "#94D0CD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5554 79.3375C27.5722 79.6503 28.1438 80.7308 27.832 81.7508L24.4453 92.833C24.1336 93.8531 23.0566 94.4265 22.0398 94.1138C21.023 93.801 20.4515 92.7205 20.7632 91.7005L24.1499 80.6183C24.4617 79.5982 25.5386 79.0248 26.5554 79.3375Z",
    fill: "#94D0CD"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLessondone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/lessondone.965181d3657023f15de1af934c5943d2.blank.svg";